import { Routes } from '@angular/router';

export const routes: Routes = [
	// Rota raiz - redireciona para /login
	{
		path: '',
		redirectTo: 'login',
		pathMatch: 'full'
	},
	// Painel de fornecedor na raiz
	{
		path: '',
		loadChildren: () => import('./features/painel/painel-module').then(m => m.PainelModule)
	},
	// Catch-all - redireciona para /login
	{
		path: '**',
		redirectTo: 'login',
		pathMatch: 'full'
	}
];
